import React, { useState } from 'react';
import { Tooltip } from 'antd';
import { Button, Icon, Modal } from '@gerdau/hefesto';
import { getTaggingInformationScreen } from '../../../utils/Tagging';
import { sendTagging } from '../../../store/ducks/tagging/actions';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

interface IRemoveItemButtonProps {
  onRemoveItem(): void;
  className?: string;
  disabled?: boolean;
  tooltipMessage?: string;
  isResponsibleOfConstructionPage?: boolean;
}

const RemoveItemButton: React.FC<IRemoveItemButtonProps> = ({
  onRemoveItem,
  disabled = false,
  tooltipMessage,
  isResponsibleOfConstructionPage = false
}) => {
  const [canShowConfirmModal, setCanShowConfirmModal] = useState(false);

  const onRemoveClick = (event: React.MouseEvent<HTMLElement>) => {
    setCanShowConfirmModal(true);
    event.stopPropagation();
  };

  const dispatch = useDispatch();
  const history = useHistory();

  const { screenName = '', itemDescription = '' } = getTaggingInformationScreen(
    history.location.pathname,
    true
  );

  return (
    <>
      {canShowConfirmModal && (
        <Modal
          title="Deseja excluir este item?"
          onClose={() => setCanShowConfirmModal(false)}
          modalSize="lg"
          buttons={{
            left: {
              children: 'Cancelar',
              name: 'cancelar',
              onClick: () => {
                isResponsibleOfConstructionPage &&
                  dispatch(
                    sendTagging({
                      screenName: `${screenName}:ModalExcluir`,
                      itemName: 'button:cancelar',
                      event: 'click',
                      itemDescription: `${itemDescription}_modalExcluir_cancelar`
                    })
                  );
                setCanShowConfirmModal(false);
              },
              type: 'button'
            },
            right: {
              children: 'Excluir item',
              name: 'excluirItem',
              onClick: (event: React.MouseEvent<HTMLElement>) => {
                isResponsibleOfConstructionPage &&
                  dispatch(
                    sendTagging({
                      screenName: `${screenName}:ModalExcluir`,
                      itemName: 'button:excluir_item',
                      event: 'click',
                      itemDescription: `${itemDescription}_modalExcluir_excluirItem`
                    })
                  );
                event.stopPropagation();
                setCanShowConfirmModal(false);
                onRemoveItem();
              },
              type: 'button',
              variant: 'danger'
            }
          }}
        >
          <>Ao confirmar, sua ação será irreversível.</>
        </Modal>
      )}
      <>
        <Tooltip title={tooltipMessage}>
          <Button
            type="button"
            name="trashButton"
            variant="neutral"
            onClick={onRemoveClick}
            disabled={disabled}
            icon={<Icon option="Trash" variant="danger" />}
          />
        </Tooltip>
      </>
    </>
  );
};

export default RemoveItemButton;
